import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class GlobalVariableService {
  page: string;
  lastWebPage: string;
  supplyChannel: string;
  businessType: string;

  constructor() { }

  get returnPageUrl(): any {
    return this.page;
  }
  set returnPageUrl(value: any) {
    this.page = value;
  }

  get lastWebPageName(): any {
    return this.lastWebPage;
  }
  set lastWebPageName(value: any) {
    this.lastWebPage = value;
  }

  get supplyChannelName(): any {
    return this.supplyChannel;
  }
  set supplyChannelName(value: any) {
    this.supplyChannel = value;
  }

  get businessTypeName(): any {
    return this.businessType;
  }
  set businessTypeName(value: any) {
    this.businessType = value;
  }
}
